import { createBrowserHistory } from 'history';

export const createHistory = (options: { basename: string }) =>
  createBrowserHistory(options);
